/* ===========================================================
   Shivam Masale — theme scripts
   Visual behaviour carried over from the original site,
   plus Shopify cart + variant handling.
   =========================================================== */
(function () {
'use strict';

var $  = function (s, r) { return (r || document).querySelector(s); };
var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

/* ---------------------------------------------------------- money format */
function formatMoney(cents) {
  var fmt = window.SHIVAM && window.SHIVAM.moneyFormat ? window.SHIVAM.moneyFormat : '₹{{amount}}';
  var value = (cents || 0) / 100;

  function withComma(num, decimals) {
    var fixed = num.toFixed(decimals);
    var parts = fixed.split('.');
    var whole = parts[0];
    // Indian grouping: last three digits, then pairs
    var last3 = whole.slice(-3);
    var rest = whole.slice(0, -3);
    if (rest) last3 = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3;
    return parts[1] ? last3 + '.' + parts[1] : last3;
  }

  return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
    switch (name) {
      case 'amount':                              return withComma(value, 2);
      case 'amount_no_decimals':                  return withComma(value, 0);
      case 'amount_with_comma_separator':         return value.toFixed(2).replace('.', ',');
      case 'amount_no_decimals_with_comma_separator': return Math.round(value).toString();
      case 'amount_with_space_separator':         return value.toFixed(2).replace('.', ',');
      default:                                    return withComma(value, 2);
    }
  });
}
window.formatMoney = formatMoney;

/* ------------------------------------------------------------- preloader */
window.addEventListener('load', function () {
  var bar = $('#preloader-progress');
  var pre = $('#preloader');
  if (bar) bar.style.width = '100%';
  setTimeout(function () {
    if (pre) pre.classList.add('fade-out');
    document.body.classList.add('loaded');
  }, 600);
});

/* --------------------------------------------------- floating spice dust */
(function () {
  var canvas = $('#spices-canvas');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  if (!ctx) return;
  var width = canvas.width = canvas.offsetWidth;
  var height = canvas.height = canvas.offsetHeight;
  window.addEventListener('resize', function () {
    width = canvas.width = canvas.offsetWidth;
    height = canvas.height = canvas.offsetHeight;
  });
  var particles = [];
  for (var i = 0; i < 30; i++) {
    particles.push({
      x: Math.random() * width, y: Math.random() * height,
      r: Math.random() * 2 + 1,
      speedX: Math.random() * 0.4 - 0.2, speedY: Math.random() * 0.5 + 0.2,
      color: 'rgba(193,123,46,' + (Math.random() * 0.4 + 0.15) + ')',
      angle: Math.random() * Math.PI * 2, spin: Math.random() * 0.02 - 0.01
    });
  }
  (function draw() {
    ctx.clearRect(0, 0, width, height);
    particles.forEach(function (p) {
      p.y += p.speedY; p.x += p.speedX; p.angle += p.spin;
      if (p.y > height) { p.y = -10; p.x = Math.random() * width; }
      if (p.x > width) p.x = 0;
      if (p.x < 0) p.x = width;
      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.angle);
      ctx.fillStyle = p.color;
      ctx.beginPath();
      ctx.ellipse(0, 0, p.r * 1.5, p.r, 0, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
    });
    requestAnimationFrame(draw);
  })();
})();

/* ------------------------------------------------------- hero parallax */
(function () {
  var hero = $('#hero');
  if (!hero) return;
  var main = $('.pouch-main', hero), left = $('.pouch-left', hero), right = $('.pouch-right', hero);
  hero.addEventListener('mousemove', function (e) {
    var x = (window.innerWidth / 2 - e.clientX) * 0.025;
    var y = (window.innerHeight / 2 - e.clientY) * 0.025;
    if (main)  main.style.transform  = 'translate3d(' + x + 'px,' + y + 'px,0) scale(1.05)';
    if (left)  left.style.transform  = 'translate3d(' + (x * 1.4) + 'px,' + (y * 1.4) + 'px,0) rotate(-12deg)';
    if (right) right.style.transform = 'translate3d(' + (x * 0.7) + 'px,' + (y * 0.7) + 'px,0) rotate(8deg)';
  });
})();

/* ----------------------------------------------------------- navigation */
window.addEventListener('scroll', function () {
  var nav = $('#navbar');
  if (nav) nav.classList.toggle('scrolled', window.scrollY > 60);
});

(function () {
  var sections = $$('section[id], footer[id]');
  var links = $$('.nav-links a');
  if (!sections.length || !links.length) return;
  window.addEventListener('scroll', function () {
    var current = '';
    sections.forEach(function (s) {
      if (window.scrollY >= s.offsetTop - 150) current = s.getAttribute('id');
    });
    links.forEach(function (l) {
      var href = l.getAttribute('href') || '';
      l.classList.toggle('active', href.indexOf('#' + current) > -1 && current !== '');
    });
  });
})();

window.toggleDrawer = function () {
  var d = $('#drawer'), o = $('#overlay');
  if (!d) return;
  d.classList.toggle('open');
  if (o) o.classList.toggle('open');
  document.body.style.overflow = d.classList.contains('open') ? 'hidden' : '';
};

/* ------------------------------------------------------ reveal + counters */
if ('IntersectionObserver' in window) {
  var revealObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('visible'); revealObs.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  $$('.reveal').forEach(function (el) { revealObs.observe(el); });

  var counterObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target, target = parseInt(el.dataset.target, 10) || 0, cur = 0, step = target / 60;
      var t = setInterval(function () {
        cur = Math.min(cur + step, target);
        el.textContent = Math.floor(cur);
        if (cur >= target) clearInterval(t);
      }, 20);
      counterObs.unobserve(el);
    });
  }, { threshold: 0.5 });
  $$('.counter').forEach(function (el) { counterObs.observe(el); });
} else {
  $$('.reveal').forEach(function (el) { el.classList.add('visible'); });
}

/* ------------------------------------------------------------- carousel */
(function () {
  var outer = $('.carousel-track-outer');
  var track = $('#carousel');
  var bar = $('#carousel-progress');
  if (!outer || !track) return;

  window.moveCarousel = function (dir) {
    var card = track.children[0];
    var step = card ? card.offsetWidth + 20 : outer.clientWidth * 0.8; // 20px matches .carousel-track gap
    outer.scrollBy({ left: dir * step, behavior: 'smooth' });
  };

  function updateProgress() {
    if (!bar) return;
    var max = outer.scrollWidth - outer.clientWidth;
    var ratio = max > 0 ? outer.scrollLeft / max : 0;
    bar.style.transform = 'scaleX(' + (1 + ratio * 2.33) + ')';
  }

  outer.addEventListener('scroll', updateProgress, { passive: true });
  window.addEventListener('resize', updateProgress);
  updateProgress();
})();

/* --------------------------------------------------------- testimonials */
(function () {
  var cards = $$('.testi-card');
  var dots = $$('.tdot');
  if (cards.length < 2) return;
  var active = 0;
  window.setTesti = function (i) {
    active = i;
    cards.forEach(function (c, n) { c.classList.toggle('active', n === i); });
    dots.forEach(function (d, n) { d.classList.toggle('active', n === i); });
  };
  setInterval(function () { window.setTesti((active + 1) % cards.length); }, 4000);
})();

/* ------------------------------------------------------ shop filter chips */
window.setShopCat = function (cat, el) {
  $$('.shop-filter-chip').forEach(function (c) { c.classList.toggle('active', c === el); });
  var cards = $$('#shopGrid .product-card');
  var shown = 0;
  cards.forEach(function (card) {
    var match = cat === 'All' || card.dataset.cat === cat;
    card.classList.toggle('hidden', !match);
    if (match) shown++;
  });
  var count = $('#shopCount');
  if (count) count.textContent = 'Showing ' + shown + ' of ' + cards.length + ' products';
};

window.jumpToCategory = function (cat) {
  var target = document.getElementById('shop-all');
  if (target) target.scrollIntoView({ behavior: 'smooth' });
  setTimeout(function () {
    var chip = $$('.shop-filter-chip').filter(function (c) { return c.dataset.cat === cat; })[0];
    if (chip) chip.click();
  }, 500);
};

/* ------------------------------------------------------- variant pills */
document.addEventListener('click', function (e) {
  var pill = e.target.closest('.wpill');
  if (!pill) return;
  if (pill.dataset.soldout === 'true') return;
  var group = pill.closest('.weight-pills');
  if (!group) return;
  $$('.wpill', group).forEach(function (p) { p.classList.remove('active'); });
  pill.classList.add('active');

  var scope = pill.closest('[data-product-scope]') || pill.closest('.product-card');
  if (!scope) return;
  var priceEl = $('[data-price-now]', scope);
  if (priceEl && pill.dataset.price) priceEl.textContent = pill.dataset.price;
  var compareEl = $('[data-price-compare]', scope);
  if (compareEl) {
    compareEl.textContent = pill.dataset.compare || '';
    compareEl.style.display = pill.dataset.compare ? '' : 'none';
  }
  var input = $('[data-variant-input]', scope);
  if (input && pill.dataset.variantId) input.value = pill.dataset.variantId;
  var btn = $('[data-add-to-cart]', scope);
  if (btn) {
    btn.disabled = pill.dataset.soldout === 'true';
    btn.textContent = pill.dataset.soldout === 'true' ? 'Sold out' : 'Add to Cart';
  }
});

/* ------------------------------------------------------------- PDP bits */
(function () {
  $$('.pdp-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = $('.pdp-main-img img');
      if (main) main.src = thumb.dataset.full;
      $$('.pdp-thumb').forEach(function (t) { t.classList.toggle('active', t === thumb); });
    });
  });
  var qtyBox = $('.qty-box');
  if (qtyBox) {
    qtyBox.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      var input = $('input', qtyBox);
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, b.dataset.step === '-1' ? v - 1 : v + 1);
    });
  }
})();

/* =============================== CART ================================== */
var Cart = {
  busy: false,

  async add(variantId, qty, button) {
    if (this.busy || !variantId) return;
    this.busy = true;
    var original = button ? button.innerHTML : '';
    if (button) { button.classList.add('adding'); button.innerHTML = 'Adding...'; }
    try {
      var res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(qty) || 1 }] })
      });
      var data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      if (button) this.flash(button, original);
      await this.refresh();
      this.open();
    } catch (err) {
      if (button) { button.innerHTML = original; button.classList.remove('adding'); }
      alert(err.message || 'Sorry, that could not be added to the cart.');
    } finally {
      this.busy = false;
    }
  },

  flash(button, original) {
    button.innerHTML = '<svg class="icon svg-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" style="width:14px;height:14px;margin-right:6px;"><polyline points="20 6 9 17 4 12"></polyline></svg> Added!';
    button.style.background = '#2E7D32';
    button.style.color = '#FDF6EC';
    setTimeout(function () {
      button.style.background = '';
      button.style.color = '';
      button.innerHTML = original;
      button.classList.remove('adding');
    }, 1600);
  },

  async change(key, qty) {
    if (this.busy) return;
    this.busy = true;
    var items = $('#cart-items');
    if (items) items.classList.add('cart-loading');
    try {
      var res = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      await res.json();
      await this.refresh();
    } catch (e) {
      alert('Could not update the cart. Please try again.');
    } finally {
      if (items) items.classList.remove('cart-loading');
      this.busy = false;
    }
  },

  async refresh() {
    var res = await fetch(window.Shopify.routes.root + 'cart.js');
    var cart = await res.json();
    this.render(cart);
    return cart;
  },

  render(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('hidden', cart.item_count === 0);
    });
    var wrap = $('#cart-items');
    if (!wrap) return;

    if (!cart.items.length) {
      wrap.innerHTML = '<div class="cart-empty">Your cart is empty.<br/><br/>' +
        '<a href="' + window.Shopify.routes.root + 'collections/all" style="color:var(--amber-light,#E8A84A)">Browse our spices</a></div>';
    } else {
      wrap.innerHTML = cart.items.map(function (item) {
        var img = item.image
          ? '<img class="cart-line-img" src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt=""/>'
          : '<div class="cart-line-img"></div>';
        var variant = item.variant_title && item.variant_title !== 'Default Title'
          ? '<div class="cart-line-var">' + item.variant_title + '</div>' : '';
        return '<div class="cart-line" data-key="' + item.key + '">' + img +
          '<div><div class="cart-line-name"><a href="' + item.url + '">' + item.product_title + '</a></div>' +
          variant +
          '<div class="cart-qty"><button data-qty-down>&minus;</button><span>' + item.quantity +
          '</span><button data-qty-up>+</button></div>' +
          '<button class="cart-remove" data-remove>Remove</button></div>' +
          '<div class="cart-line-price">' + formatMoney(item.final_line_price) + '</div></div>';
      }).join('');
    }
    var total = $('#cart-total');
    if (total) total.textContent = formatMoney(cart.total_price);
    var checkout = $('#cart-checkout');
    if (checkout) checkout.disabled = cart.items.length === 0;
  },

  open()  { var d = $('#cart-drawer'), v = $('#cart-veil'); if (!d) return; d.classList.add('open'); if (v) v.classList.add('open'); document.body.style.overflow = 'hidden'; },
  close() { var d = $('#cart-drawer'), v = $('#cart-veil'); if (!d) return; d.classList.remove('open'); if (v) v.classList.remove('open'); document.body.style.overflow = ''; }
};
window.ShivamCart = Cart;

/* cart events */
document.addEventListener('click', function (e) {
  var add = e.target.closest('[data-add-to-cart]');
  if (add) {
    e.preventDefault();
    var scope = add.closest('[data-product-scope]') || add.closest('.product-card');
    var input = scope ? $('[data-variant-input]', scope) : null;
    var qtyInput = scope ? $('[data-qty-input]', scope) : null;
    var id = (input && input.value) || add.dataset.variantId;
    Cart.add(id, qtyInput ? qtyInput.value : 1, add);
    return;
  }

  if (e.target.closest('[data-cart-open]')) { e.preventDefault(); Cart.refresh(); Cart.open(); return; }
  if (e.target.closest('[data-cart-close]') || e.target.id === 'cart-veil') { Cart.close(); return; }

  var line = e.target.closest('.cart-line');
  if (line) {
    var key = line.dataset.key;
    var qty = parseInt($('.cart-qty span', line).textContent, 10) || 1;
    if (e.target.closest('[data-qty-up]'))   return Cart.change(key, qty + 1);
    if (e.target.closest('[data-qty-down]')) return Cart.change(key, qty - 1);
    if (e.target.closest('[data-remove]'))   return Cart.change(key, 0);
  }

  if (e.target.closest('#cart-checkout')) {
    e.preventDefault();
    window.location.href = window.Shopify.routes.root + 'checkout';
  }
});

document.addEventListener('keydown', function (e) { if (e.key === 'Escape') Cart.close(); });

/* buy it now: add then go straight to checkout */
document.addEventListener('click', async function (e) {
  var btn = e.target.closest('[data-buy-now]');
  if (!btn) return;
  e.preventDefault();
  var scope = btn.closest('[data-product-scope]');
  var input = scope ? $('[data-variant-input]', scope) : null;
  var qtyInput = scope ? $('[data-qty-input]', scope) : null;
  await Cart.add(input && input.value, qtyInput ? qtyInput.value : 1, null);
  window.location.href = window.Shopify.routes.root + 'checkout';
});

/* keep the badge honest on back/forward navigation */
window.addEventListener('pageshow', function (e) { if (e.persisted) Cart.refresh(); });


/* ============================ VIDEO LIGHTBOX =========================== */
(function () {
  function ensureLightbox() {
    var el = document.getElementById('video-lightbox');
    if (el) return el;
    el = document.createElement('div');
    el.id = 'video-lightbox';
    el.innerHTML =
      '<div class="vl-inner">' +
                '<div class="vl-bar"><div class="vl-title"></div>' +
        '<button class="vl-close" aria-label="Close video">&#10005;</button></div>' +
        '<div class="vl-frame"></div>' +
      '</div>';
    document.body.appendChild(el);
    return el;
  }

  function close() {
    var box = document.getElementById('video-lightbox');
    if (!box) return;
    box.classList.remove('open');
    box.querySelector('.vl-frame').innerHTML = '';   // stops playback
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.video-thumb');
    if (thumb) {
      e.preventDefault();
      var src = thumb.dataset.video;
      if (!src) return;
      var box = ensureLightbox();
      var frame = box.querySelector('.vl-frame');
      // Instagram reels are tall, so give them a portrait frame
      frame.classList.toggle('portrait', src.indexOf('instagram.com') > -1);
      box.querySelector('.vl-title').textContent = thumb.dataset.title || '';
      frame.innerHTML = '<iframe src="' + src + '" allow="accelerometer; autoplay; clipboard-write; ' +
        'encrypted-media; gyroscope; picture-in-picture" allowfullscreen loading="lazy"></iframe>';
      box.classList.add('open');
      document.body.style.overflow = 'hidden';
      return;
    }
    if (e.target.closest('.vl-close') || e.target.id === 'video-lightbox') close();
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();


/* ========================= HERO PHOTO SLIDESHOW ======================== */
(function () {
  var box = document.querySelector('[data-hero-slideshow]');
  if (!box) return;
  var slides = Array.prototype.slice.call(box.querySelectorAll('.hero-slide'));
  if (slides.length < 2) return;

  var FADE_MS = 1400;                                   // must match .hero-slide's CSS transition
  var delay = parseInt(box.dataset.interval, 10) || 5000;
  var zoomDuration = delay + FADE_MS;                    // zoom runs the whole time a slide is visible
  var i = 0;
  var timer = null;

  function img(slide) { return slide.querySelector('img'); }

  function primeZoomSpeed(slide) {
    var el = img(slide);
    if (el) el.style.transitionDuration = zoomDuration + 'ms';
  }

  // start every slide zoomed out, ready to zoom in the instant it becomes active
  slides.forEach(primeZoomSpeed);
  if (img(slides[0])) requestAnimationFrame(function () { slides[0].classList.add('zoomed'); });

  function show(n) {
    var prev = slides[i];
    i = (n + slides.length) % slides.length;
    var next = slides[i];

    prev.classList.remove('active');                    // starts the 1.4s opacity fade-out
    next.classList.add('active');
    requestAnimationFrame(function () { next.classList.add('zoomed'); });

    // only reset the outgoing slide's zoom once it's fully invisible —
    // resetting any earlier is what caused the visible "zoom out" snap.
    setTimeout(function () {
      var el = img(prev);
      if (!el) return;
      el.style.transitionDuration = '0ms';
      prev.classList.remove('zoomed');
      void el.offsetWidth;                               // force the reset to apply instantly
      el.style.transitionDuration = zoomDuration + 'ms';
    }, FADE_MS);
  }

  function start() { stop(); timer = setInterval(function () { show(i + 1); }, delay); }
  function stop()  { if (timer) { clearInterval(timer); timer = null; } }

  // don't burn battery while the tab is hidden
  document.addEventListener('visibilitychange', function () {
    document.hidden ? stop() : start();
  });

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  start();
})();

})();
